import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["searchInput", "typeSelect", "canvasSelect", "results"]
  static values = {
    url: String,
    debounce: { type: Number, default: 300 }
  }

  connect() {
    this.timeout = null
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout)
  }

  search() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.fetchResults()
    }, this.debounceValue)
  }

  selectFilter() {
    this.fetchResults()
  }

  fetchResults() {
    const url = new URL(this.urlValue, window.location.origin)

    // Add search query if present
    const searchValue = this.searchInputTarget.value.trim()
    if (searchValue) {
      url.searchParams.set("q[name_or_description_cont]", searchValue)
    }

    // Add document type filter if selected
    const documentType = this.typeSelectTarget.value
    if (documentType) {
      url.searchParams.set("document_type", documentType)
    }

    // Add canvas filter if selected
    if (this.hasCanvasSelectTarget) {
      const canvasId = this.canvasSelectTarget.value
      if (canvasId) {
        url.searchParams.set("canvas_id", canvasId)
      }
    }

    // Update browser URL
    window.history.replaceState({}, "", url)

    // Fetch and update the results frame
    fetch(url, {
      headers: {
        "Turbo-Frame": "documents-list",
        "Accept": "text/html"
      }
    })
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser()
        const doc = parser.parseFromString(html, "text/html")
        const newFrame = doc.querySelector("turbo-frame#documents-list")
        if (newFrame && this.resultsTarget) {
          this.resultsTarget.innerHTML = newFrame.innerHTML
        }
      })
  }
}
